import { render } from "./layout-main.vue?vue&type=template&id=8cc6d900&scoped=true"
const script = {}

import "./layout-main.vue?vue&type=style&index=0&id=8cc6d900&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc6d900"]])

export default __exports__